<ng-container *ngIf="matchService.match && !loading">
  <div class="match-header" *ngIf="matchService.teams">
    <div class="match-toolbar">
      <button
        mat-icon-button
        class="match-menu-button"
        [class.open]="menuOpen"
        (click)="toggleMenu()"
      >
        <mat-icon>ios_share</mat-icon>
        <div *ngIf="menuOpen" class="match-menu">
          <button (click)="onCopyTickerLink()">
            <mat-icon>content_copy</mat-icon>
            Link zum Spiel kopieren
          </button>
        </div>
      </button>
    </div>
    <div class="match-info">
      <a [href]="homeTeamLink" target="_blank" class="match-info-team">
        <img
          [src]="matchService.teams.home.pictures | imageUrlBySubtype"
          alt="Team Logo"
        />
        <span>{{ matchService.teams.home.name }}</span>
      </a>
      <div class="match-info-details">
        <ng-container
          *ngIf="
            matchService.match.isInAutoMode() || matchService.match.isPreGame()
          "
        >
          <span class="date">{{ matchDate | date : 'dd.MM.yyyy' }}</span>
          <span class="time">{{ matchDate | date : 'HH:mm' }}</span>
        </ng-container>
        <ng-container *ngIf="matchService.match.isActive()">
          <span class="status" *ngIf="!matchService.match.isPenalty()">
            <div class="live-indicator"></div>
            {{ matchService.currentMinute }}
          </span>
          <span class="status" *ngIf="matchService.match.isPenalty()">
            <div class="live-indicator"></div>
            {{ matchService.getStatusString() }}
          </span>
          <span class="score"
          >{{ matchService.scores.home }} :
            {{ matchService.scores.away }}</span
          >
          <span class="score-small" *ngIf="matchService.showRegularScore()">
            ({{ matchService.getRegularScore() }})
          </span>
        </ng-container>
        <ng-container *ngIf="matchService.match.isCancelled()">
          <span class="status">
            {{ matchService.getStatusString() }}
          </span>
          <span class="date">{{ matchDate | date : 'dd.MM.yyyy' }}</span>
        </ng-container>
        <ng-container *ngIf="matchService.match.isPostGame()">
          <span class="status" *ngIf="matchService.match.hasPenalty()"
          >Elfmeter</span
          >
          <span class="status" *ngIf="matchService.match.hasOvertime()"
          >Nach VL</span
          >
          <span class="status" *ngIf="!matchService.showRegularScore()"
          >Endstand</span
          >
          <span class="score"
          >{{ matchService.scores.home }} :
            {{ matchService.scores.away }}</span
          >
          <span class="score-small" *ngIf="matchService.showRegularScore()">
            ({{ matchService.getRegularScore() }})
          </span>
        </ng-container>
        <ng-container *ngIf="matchService.match.isEnded()">
          <span class="date">
            {{ matchDate | date : 'dd.MM.yyyy' }}
          </span>
          <span class="score"
          >{{ matchService.scores.home }} :
            {{ matchService.scores.away }}</span
          >
        </ng-container>
      </div>
      <a class="match-info-team" target="_blank" [href]="awayTeamLink">
        <img
          [src]="matchService.teams.away.pictures | imageUrlBySubtype"
          alt="Team Logo"
        />
        <span>{{ matchService.teams.away.name }}</span>
      </a>
    </div>
    <nav #navElement class="match-nav">
      <ng-container *ngFor="let tab of matchService.tabs">
        <a
          *ngIf="tab.active"
          [routerLink]="tab.path"
          routerLinkActive="active"
          (click)="onNavClicked(tab.path)"
        >
          {{ tab.name }}
        </a>
      </ng-container>
    </nav>
  </div>
  <div class="match-outlet" *ngIf="!this.matchService.loading">
    <lib-match-top-banner
      *ngIf="!adCampaignService.showCampaign || !adCampaignService.campaign"
      style="margin-bottom: 20px"
    ></lib-match-top-banner>
    <lib-ad-sponsor-banner
      [lightHeading]="true"
      [useDomain]="true"
      [entityId]="matchService.match._id"
      [entityType]="entityType"
    >
    </lib-ad-sponsor-banner>
    <router-outlet></router-outlet>
  </div>
</ng-container>
<mat-spinner
  *ngIf="loading"
  class="loading-spinner"
  color="primary"
  diameter="54"
  strokeWidth="2"
></mat-spinner>
